module.exports = __webpack_public_path__ + "static/media/electricalAppliances.dc08729e.png";